import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
      <Typography variant="caption">&copy; {new Date().getFullYear()} All rights reserved</Typography>
      <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
        <Link component={RouterLink} to="https://hackerest.com/#about" target="_blank" variant="caption" color="text.primary">
          About us
        </Link>
        <Link component={RouterLink} to="https://hackerest.com/privacy" target="_blank" variant="caption" color="text.primary">
          Privacy
        </Link>
        <Link component={RouterLink} to="https://hackerest.com/terms" target="_blank" variant="caption" color="text.primary">
          Terms
        </Link>
      </Stack>
    </Stack>
  );
}
